import { render } from "./d-prediction-1.vue?vue&type=template&id=7ae49a19&scoped=true&ts=true"
import script from "./d-prediction-1.vue?vue&type=script&lang=ts"
export * from "./d-prediction-1.vue?vue&type=script&lang=ts"

import "./d-prediction-1.vue?vue&type=style&index=0&id=7ae49a19&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae49a19"]])

export default __exports__